import TouchableOpacity from "../TouchableOpacity";
import { themeColors } from "../../config";
const Button = ({ children, onClick, style }) => {
  return (
    <TouchableOpacity
      onClick={onClick}
      style={{
        borderRadius: 10,
        padding: 10,
        backgroundColor: themeColors.contentColor,
        color: themeColors.contentTextColor,
        fontFamily: "roboto",
        ...style,
      }}
    >
      {children}
    </TouchableOpacity>
  );
};
export default Button;
